@if (openButtonLabel()) {
  <button (click)="open()" (mousedown)="$event.preventDefault()" class="pause-dialog__button">
    @if (openButtonIcon()) {
      <i [class]="openButtonIcon()"></i>
    }
    {{openButtonLabel() ?? '' | translate}}
  </button>
} @else {
  <tar-icon-button (click)="open()" (mousedown)="$event.preventDefault()" icon="ph ph-pause ph-bold ph-fill" type="secondary" ariaLabel="Pause"></tar-icon-button>
}
<tar-dialog [key]="dialogKey"></tar-dialog>
